import { useEffect, useState } from "react";
import { PRODUCER_API } from "../../../../Utilities/APIs/APIs";
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance";
import Form from "../../../Partials/Layouts/Forms/Form";
import SelectInput from "../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput";
import SelectOption from "../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption";
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";


function CreateEventProducer({ setShowCreateForm, setShowModal, triggerFetch, eventId }) {


    const [producers, setProducers] = useState([])
    const [producer, setProducer] = useState(null)
    const axiosInstance = useAxiosInstance();


    useEffect(() => {

        async function fetchAndSetCountries() {
            const { data } = await axiosInstance.get(`${PRODUCER_API}notAssignedToEvent/${eventId}`)
            setProducers(data)
        }
        fetchAndSetCountries()

    }, [ eventId])




    async function handleSubmit(e) {
        e.preventDefault();

        const itemData = { event: eventId, producer: producer }


        const response = await axiosInstance.post(PRODUCER_API, itemData);

        if (response) {
            setShowCreateForm(false);
            setShowModal(false);
            triggerFetch();
        }
    }

    return (


        // <div style={{ height: "70vh" }}>
            <Form onSubmit={handleSubmit} hasImage>


                <SelectInput value={producer} setState={setProducer} label={"Select Producer"}>
                    <SelectOption optionText={"Select Producer"} optionValue={""} />
                    {
                        producers && producers.length > 0 && producers?.map(producer =>
                            <SelectOption key={producer._id} optionText={producer?.name} optionValue={producer?._id} />
                        )
                    }
                </SelectInput>



                <div style={{ height: "10vh" }}>
                    <FormSubmitButton text="Create Event Producer" />
                </div>
            </Form>
        // </div>
    );
}

export default CreateEventProducer;
